import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Dropdown, DropdownDivider, DropdownMenu, Icon } from "semantic-ui-react";

import "components/NavBar/components/NotificationsBellButton/NotificationsBellButton.scss";
import {
  clearAppNotifications,
  removeAppNotification,
  toggleNotificationsCenterVisibility,
  useAppNotifications,
  useIsNotificationsCenterOpen
} from "components/NotificationsCenter/hooks";
import { PATHS } from "router/paths";

export const NotificationsBellButton = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const dropdownRef = useRef<HTMLDivElement>(null);
  const appNotifications = useAppNotifications();
  const isNotificationsCenterOpen = useIsNotificationsCenterOpen();

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (isNotificationsCenterOpen && dropdownRef.current && e.target instanceof Node && !dropdownRef.current.contains(e.target)) {
        toggleNotificationsCenterVisibility();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isNotificationsCenterOpen]);

  const handleScrollToNotifications = () => {
    const sectionId = "account-settings-notifications-section";

    if (location.pathname === PATHS.ACCOUNT) {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    history.push({ pathname: PATHS.ACCOUNT, state: { scrollTo: sectionId } });
    toggleNotificationsCenterVisibility();
  };

  return (
    <div ref={dropdownRef}>
      <Dropdown
        icon={null}
        className="NotificationsBellButton"
        open={isNotificationsCenterOpen}
        trigger={
          <div className="app-notifications-wrapper" onClick={toggleNotificationsCenterVisibility}>
            <Icon className="bell" />
            {appNotifications.length ? <span className="app-notifications-count">{appNotifications.length}</span> : null}
          </div>
        }
      >
        <DropdownMenu className="actions-menu" direction="left">
          <div className="container">
            <div>
              <Button type="button" className="light button" onClick={clearAppNotifications}>
                <div className="button-container">
                  {t("v8_clear_all", "Clear All")}
                  <div>
                    <Icon className="check double" />
                  </div>
                </div>
              </Button>
            </div>

            <div className="icons-container">
              <Icon className="gear" onClick={handleScrollToNotifications} />
              <Icon className="xmark pointer" onClick={toggleNotificationsCenterVisibility} />
            </div>
          </div>
          <DropdownDivider />

          <div className="app-notification">
            {appNotifications.map(({ id, title, description, time, icon, onClick }) => (
              <div key={id} className="container">
                <div
                  className="notification-title"
                  onClick={() => {
                    onClick();
                    removeAppNotification(id);
                  }}
                >
                  <div className="title-container">
                    <div>
                      <Icon circular className={icon} />
                    </div>
                    <span>{time}</span>
                    <span>{title} </span>
                  </div>
                  <div className="description-container">
                    <span className="description"> {description} </span>
                  </div>
                </div>

                <div onClick={() => removeAppNotification(id)}>
                  <Icon className="xmark" />
                </div>
              </div>
            ))}
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
